import { render, staticRenderFns } from "./OtherLabInvestigations.vue?vue&type=template&id=2a05e412&scoped=true&"
import script from "./OtherLabInvestigations.vue?vue&type=script&lang=js&"
export * from "./OtherLabInvestigations.vue?vue&type=script&lang=js&"
import style0 from "./OtherLabInvestigations.vue?vue&type=style&index=0&id=2a05e412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05e412",
  null
  
)

export default component.exports